import type { BookingListApiData } from '@navio/nsdk';
import { filterUnitFor } from 'noddi-ui-web';

/** Params a booking filter may write; paging, sort and search belong to the list. */
export type BookingListFilterInput = Omit<
  NonNullable<BookingListApiData['query']>,
  'pageIndex' | 'pageSize' | 'ordering' | 'search'
>;

export const bookingFilterUnit = filterUnitFor<BookingListFilterInput>();

/** Toolbar date range of a booking list. */
export const bookingToolbarDateRange = bookingFilterUnit.toolbarDateRange({ from: 'fromDate', to: 'toDate' });
